import { observer } from "mobx-react-lite"
import React from "react"
import { useStores } from "../../models"
import styled from '~/ui/styled'
import { EventListItem } from "./event-list-item"

interface Props {}

const Container = styled.View`
  flex: 1;
  margin-top: 8px;
  background-color: #e3e6ec;
`

const Text = styled.Text`
  text-decoration: underline;
  color: blue;
`

const Title = styled.Text`
  font-size: 14px;
`
const List = styled.FlatList`
  padding: 4px;
  background-color: #fff;
`

const ClearButton = styled.TouchableOpacity``

const Row = styled.View`
  padding: 4px;
  flex-direction: row;
  justify-content: space-between;
`

const EventList: React.FC<Props> = () => {
  const { eventStore } = useStores()
  return (
    <Container>
      <Row>
        <Title>事件列表</Title>
        <ClearButton
          onClick={() => {
            eventStore.clearEvents()
          }}
        >
          <Text>{"[清除]"}</Text>
        </ClearButton>
      </Row>
      <List
        showsVerticalScrollIndicator={true}
        keyExtractor={(item, idx) => idx}
        data={eventStore.items}
        renderItem={({ item }) => (
          <EventListItem
            onReplay={() => {
              eventStore.apply(item)
            }}
            event={item}
          />
        )}
      />
    </Container>
  )
}

export default observer(EventList)
